import { defineMessages } from '@formatjs/intl';

export const messages = defineMessages({
	heading: {
		id: 'signup.ineligible.heading',
		defaultMessage: 'Welcome back to Calm!',
		description: 'Heading shown to user when they are ineliglible for free trial offer',
	},
	subheading: {
		id: 'signup.ineligible.subheading',
		defaultMessage: 'Unfortunately, you’re not eligible for this offer.',
		description: 'Copy shown to user when they are ineliglible for free trial offer',
	},
	cta: {
		id: 'signup.ineligible.cta',
		defaultMessage: 'Subscribe to Calm Premium',
		description: 'Button copy that takes user to premium signup',
	},
});
